export const promotionTypes = {
  blackFriday: 'black_friday',
};

export default promotionTypes;
